import React, { useState, useMemo, useContext } from "react";
import { remove } from "@/components/Joyspace/api/collections";
import { PageType } from "@/components/Joyspace/const";
import events from "@/components/Joyspace/context/events";
import { Icons } from "@/components/Joyspace/Icon";
import { message, Popover } from "antd";
import IconFont from "@/components/icon";
import { ActionFnEnum, ActionType, ContextMenuMode, FileType } from "@/components/Joyspace/types";
import "./index.less";
import { analysisLog } from "@/utils/logAnalytics";
import GlobalContext from "@/context/GlobalContext";

interface IProps {
  contextMenuMode?: ContextMenuMode;
  pageId: any;
  fileType: FileType;
  onChange?: () => void;
  type: any; // 文档详细类型
  callbackProps?: any;
}

export default function CollectionPopover(props: IProps) {
  const {
    contextMenuMode = ContextMenuMode.Click,
    pageId = "",
    fileType = FileType.Page,
    onChange,
    type = "",
    callbackProps = {}
  } = props;
  const [popoverVisible, setPopoverVisible] = useState<boolean>(false);
  const [disabled, setDisabled] = useState(false);
  const { onLine } = useContext(GlobalContext);

  const handleVisibleChange = () => {
    setPopoverVisible(!popoverVisible);
  };
  const content = useMemo(() => {
    return (
      <ul
        onContextMenu={(event) => {
          event.stopPropagation();
        }}
        className={
          disabled
            ? "joyspace-operate-lists joyspace-operate-lists-disabled"
            : "joyspace-operate-lists"
        }
      >
        <li
          onClick={() => {
            if (disabled) {
              return;
            }
            analysisLog("xtbg_jzb_joyspace_home_1676548210761", "9", "collections", pageId, type);
            setPopoverVisible(false);
            remove(pageId, fileType)
              .then((res) => {
                message.success("操作成功");
                callbackProps?.setData({
                  type: ActionFnEnum.REMOVE,
                  id: pageId,
                  actionType: ActionType.Page
                } as any);
              })
              .catch((err) => {
                message.error("操作失败");
              });
            onChange?.();
          }}
        >
          <IconFont
            type="iconpc_yundocument_inshare"
            className="joyspace-collection-operate-icon"
          />
          取消收藏
        </li>
      </ul>
    );
  }, [callbackProps, disabled, fileType, onChange, pageId, type]);
  useMemo(() => {
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  if (contextMenuMode === ContextMenuMode.ContextMenu) {
    return <div className="collection-contextMenu">{content}</div>;
  }
  return (
    <div>
      <Popover
        trigger="click"
        placement="bottomRight"
        onVisibleChange={handleVisibleChange}
        visible={popoverVisible}
        overlayClassName="collection-popover"
        content={content}
      >
        <a
          href="#"
          type="default"
          onContextMenu={(event) => {
            event.stopPropagation();
          }}
        >
          <span
            className={
              popoverVisible
                ? "joyspace-trigger-icon joyspace-trigger-actions"
                : "joyspace-trigger-icon"
            }
          >
            {Icons.trigger}
          </span>
        </a>
      </Popover>
    </div>
  );
}
